module.exports = __webpack_public_path__ + "static/media/main_bg.93407c7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/index/img/main_bg.png
// module id = 1500
// module chunks = 0